'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ../~/gatsby/~/react-router-scroll/~/scroll-behavior/~/dom-helpers/util/inDOM.js
// module id = 238
// module chunks = 0